import { Component, OnInit } from '@angular/core';
import { distinctUntilChanged, map } from 'rxjs';
import { ClienteTemaResponse } from '../../_infrastructure/dtos/core/cliente/cliente-tema/ClienteTemaResponse';
import { ClienteContextService } from '../../_infrastructure/context-service/cliente/cliente-context.service';
import { UnsubscribeOnDestroyAdapter } from '../../_shared';

@Component({
  selector: 'app-transparencia-layout',
  templateUrl: './transparencia-layout.component.html',
  styleUrls: ['./transparencia-layout.component.css'],
  standalone: false
})
export class TransparenciaLayoutComponent extends UnsubscribeOnDestroyAdapter implements OnInit {

  constructor(
    private readonly clienteContextService: ClienteContextService
  ) {
    super();
  }

  ngOnInit(): void {
    this.subs.sink = this.clienteContextService.getCliente().pipe(
      map((cliente) => this.getConfiguracaoTemaExterno(cliente.clienteTemas)),
      distinctUntilChanged()
    ).subscribe((configuracao) => {
      //Descomentar o trexo abaixo quando finalizar a configuração dos temas
      // if (configuracao) {
      //   document.documentElement.setAttribute('data-theme', configuracao);
      //   return;
      // }

      // document.documentElement.removeAttribute('data-theme');
    });
  }

  private getConfiguracaoTemaExterno(clienteTemas?: ClienteTemaResponse[]): string | undefined {
    return clienteTemas
      ?.find((clienteTema) => clienteTema.areaExterna && !!clienteTema.tema?.configuracao)
      ?.tema.configuracao;
  }
}
